// extracted by mini-css-extract-plugin
module.exports = {"categoriesList":"styles_categoriesList__3HkO2","categoryItem":"styles_categoryItem__2Ql_K"};